exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-icon {\n  width: 90px;\n  border-radius: 20px;\n  border: 1px solid #ccc;\n}\n", ""]);

// exports
